import React from 'react';
import Interno from './interno';
import {Error} from './error/Error';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { useSignals } from '@preact/signals-react/runtime';

const montarBasenameRouter = (basename) => {
    const segmento = String(basename || '')
        .trim()
        .replace(/^\/+|\/+$/g, '');
    return segmento ? `/${segmento}` : undefined;
};

const Home = () => {
    useSignals();
    return (
        <BrowserRouter basename={montarBasenameRouter(global.gConfig.basename)}>
            {
                <div>
                    <Routes>
                        <Route path="/erro" exact element={<Error />} />
                        <Route path="*" element={<Interno />}  />
                    </Routes>                  
                </div>
            }
        </BrowserRouter>
    );
};

export default Home;
